import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    createBulkTransferFailed:
      'An error occurred while creating your transfers. Please try again in a few minutes and don’t hesitate to contact us if the error remains.',
    listLabel: 'The document contains the following {0} transfers:',
    newRecipientsInfo: {
      many: 'We have detected {0} new beneficiaries. We have saved them for you.\nFind them by clicking on Payments > Beneficiaries.',
      one: 'We have detected {0} new beneficiary. We have saved them for you.\nFind them by clicking on Payments > Beneficiaries.',
    },
    sendAllTransfers: 'Send all transfers',
    title: 'Your transfers at a glance',
  },
  fr: {
    cancel: 'Annuler',
    createBulkTransferFailed:
      'Une erreur est survenue lors de la création de vos virements. Veuillez réessayer dans quelques minutes et n’hésitez pas à nous contacter si le problème persiste.',
    listLabel: 'Le document contient les {0} virements suivants :',
    newRecipientsInfo: {
      many: 'Nous avons détecté {0} nouveaux bénéficiaires. Nous les avons enregistrés pour vous.\nRetrouvez-les en cliquant sur Paiements > Mes\xA0bénéficiaires.',
      one: "Nous avons détecté {0} nouveau bénéficiaire. Nous l'avons enregistré pour vous.\nRetrouvez-le en cliquant sur Paiements > Mes\xA0bénéficiaires.",
    },
    sendAllTransfers: 'Envoyer tous les virements',
    title: 'Coup d’œil sur vos virements',
  },
} as const);

export default locales;
